export const environment = {
  production: true,
  disableSentry: false,
  tiptapSseInitialSyncDeadlineMs: 60_000,
  tiptapPollIntervalMs: 500,
}
